import React, { useState, useRef, useEffect } from 'react';

import useIsFirstRender from '../is_first_render.js'
import useScaled from '../use_scaled.js'
import useKeysByOption from '../useKeysByOption.jsx'

import OptionKeys from './OptionKeys.jsx'
import { OptionLabel, optionByAngle } from './Options.jsx'

import DarkCoverImageSrc from 'images/folder-topaz-denoise-enhance-2x_dark.jpg'
import PROYECTO_REFUGIO_IMAGE_PATH from 'images/proyecto_refugio.png'

import initialSpinnerShow from '../initial_spinner_control.js'
import exploreMeShow from '../explore_me_control.js'

import { gsap } from 'gsap'

const playFadeAnimation = (element,timeline_ref, onComplete, reverse = false) => {
	if(timeline_ref.current){
		timeline_ref.current.pause(0).progress(0)
	} else {
		timeline_ref.current = gsap.timeline({ paused: true })

		timeline_ref.current.fromTo(element, {
			opacity: 1,
			scale: 1,
			z: 1000
		},
		{
			opacity: 0,
			z: 500, // mueve "hacia adelante"
			scale: 10,
			duration: 1,
			ease: 'linear'
		})
	}

	const timeline = timeline_ref.current


	if (reverse) {
		timeline.eventCallback('onReverseComplete', onComplete);
		timeline.reverse(0);
	} else {
		timeline.eventCallback('onComplete', onComplete);
		timeline.play();
	}
}

// outline-1 outline
// TODO:
// - Less redraws
// - Delegate to CSS whanever possible to prevent position artifacts.
// - opt has w 0 and h 0 on smartphone vertical. Maybe getBoundingClientRect() not doing his job
// - Changing horizontal then vertical solves the issue
const HealingMenu = ({ onOptionSelect, is_active })=>{
	const [overed_option, setOveredOption] = useState(-1);
	const [animation_state, setAnimationState] = useState('normal')
	const [key_positions_by_ring_index, setKeyPositionsByRingIndex] = useState([]);

	const is_first_render = useIsFirstRender()

	const cover_ref = useRef();
	const root_ref = useRef();
	const timeline_ref = useRef();

	const [
		[cover_w, cover_h, cover_t, cover_l],
		setNaturalSize
	] = useScaled({
		focus_height: 1.15,
		root_ref
	})

	useEffect(()=>{
		if(is_active && !is_first_render){
			setAnimationState('starting')

			playFadeAnimation(
				cover_ref.current,
				timeline_ref,
				()=> setAnimationState('normal'),
				true
			)
		}
	}, [is_active])

	const onOptionEnter = option_index =>{
		setAnimationState('exiting')

		playFadeAnimation(
			cover_ref.current,
			timeline_ref,
			()=> onOptionSelect(option_index)
		)
	}

	const center_x = cover_l + 0.5165 * cover_w
	const center_y = cover_t + 0.4953 * cover_h

	useEffect(()=>{
		const onPointerMove = ({ clientX, clientY })=>{
			if(!is_active){
				return
			}

			const mouse_angle = Math.atan2(clientY - center_y, clientX - center_x)

			const new_overed_option = optionByAngle(mouse_angle)

			if(new_overed_option !== -1){
				exploreMeShow(false)
			}
			//console.log(new_overed_option)
			setOveredOption(new_overed_option)
		}

		root_ref.current.addEventListener('pointermove', onPointerMove)

		return ()=> root_ref.current.removeEventListener('pointermove', onPointerMove)
	}, [center_x, center_y, is_active])

	useEffect(()=>{
		const onClick = ({ clientX, clientY })=>{
			if(!is_active){
				return
			}

			const mouse_angle = Math.atan2(clientY - center_y, clientX - center_x)

			const clicked_option = optionByAngle(mouse_angle)

			//console.log("onClick: new_overed_option", new_overed_option, overed_option)


			if((clicked_option !== -1) && (clicked_option == overed_option)){
				setOveredOption(clicked_option)

				onOptionEnter(clicked_option)
			}

			setOveredOption(clicked_option)
		}

		root_ref.current.addEventListener('pointerdown', onClick)

		return ()=> root_ref.current.removeEventListener('pointerdown', onClick)
	}, [center_x, center_y, overed_option, is_active])

	// TODO rect
	const keys_by_option = useKeysByOption(
		cover_w, cover_h,
		cover_t, cover_l,
		center_x, center_y
	)

	const animating = animation_state !== 'normal'
	const valid_overed_option = overed_option !== -1
	const show_option_label = valid_overed_option && !animating

	const proyecto_refugio_rect = {
		left:  cover_l + 0.5165 * cover_w,
		top:  cover_t + 0.4835 * cover_h,
		width: 0.023 * cover_w,
		height: 0.505 * cover_h
	}

	return (
		<div
			ref={root_ref}
			className={`
-				w-screen h-screen
				relative flex
				top-0 left-0
				justify-center items-center
				overflow-hidden
				${show_option_label ? 'cursor-pointer' : ''}
			`}
		>
			<img
				ref={cover_ref}
				className={`max-w-none max-h-none min-h-none min-w-none block`}
				style={{
					perspective: '1000px',
					transformStyle: 'preserve-3d',
				}}
				src={DarkCoverImageSrc}
				width={`${cover_w}px`}
				height={`${cover_h}px`}
				onLoad={({target: { naturalWidth, naturalHeight }})=> {
					initialSpinnerShow(false)
					setNaturalSize([naturalWidth, naturalHeight])
				}}
			/>

			{show_option_label && (<OptionLabel
				option_index={overed_option}
				cover_w={cover_w}
				cover_h={cover_h}
				center_x={center_x}
				center_y={center_y}
			/>)}

			{!animating && is_active && _.take(keys_by_option,8).map((keys, option_index) =>
				<OptionKeys
					keys={keys}
					key={'key-' + option_index}
					overed={option_index == overed_option}
				/>
			)}

			{!animating && <img
				src={PROYECTO_REFUGIO_IMAGE_PATH}
				className={`absolute -translate-x-1/2 -translate-y-1/2`}
				style={{
					left: `${proyecto_refugio_rect.left}px`,
					top: `${proyecto_refugio_rect.top}px`,
					width: `${proyecto_refugio_rect.width}px`,
					height: `${proyecto_refugio_rect.height}px`
				}}
			/>}
	</div>);
}

export default React.memo(HealingMenu);